import React from "react";
import { BrowserRouter } from 'react-router-dom';
import "./App.css";
import Header from "./components/macroComponent/Home/Header";
import AppRouter from "./routes/AppRouter";
import Footer from "./components/macroComponent/Footer";



function App() {

  return (
    <>
      <div className="App">
        <BrowserRouter>
        <Header />
        <AppRouter />
        <Footer />
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
